module.exports = __webpack_public_path__ + "img/辅助核算余额表.373508fc.png";